export const fromIsn = (isnData) => {
    return {
        ClientEmail: isnData.contactEmail,
        ClientName: isnData.contactName,
        ClientPhone: isnData.contactPhone,
        PropertyAddress1: isnData.address1,
        PropertyAddress2: isnData.address2,
        PropertyCity: isnData.city,
        PropertyState: isnData.state,
        PropertyCounty: isnData.county,
        PropertyPostalCode: isnData.postalCode,
        PropertyCountry: isnData.country,
    }
}


// WEBPACK FOOTER //
// src/utils/convertToDynamicValues.js